<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="处理状态" prop="processStatus" >
        <a-select v-model="form.processStatus" placeholder="请选择处理状态" @change="changeStatus">
          <a-select-option :value="2">已处理</a-select-option>
          <a-select-option :value="3">暂不处理</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="处理结果" prop="processResult" >
        <a-input v-model="form.processResult" placeholder="请输入处理结果" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getUserReport, addUserReport, updateUserReport } from '@/api/platform/userReport'
import Editor from '@/components/Editor'
import {delTable} from "@/api/tool/gen";
import request from "@/utils/request";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      resourceType: null,
      resourceId: null,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        type: null,

        content: null,

        resourceId: null,

        resourceType: null,

        processStatus: 0,

        processResult: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        userId: [
          { required: true, message: '用户id，外键{user.id}不能为空', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '举报类型：1-政治反动内容 2-低俗色情内容 3-垃圾广告信息 4-恶意攻击谩骂 5-侵权抄袭冒充 6-其他违规不能为空', trigger: 'change' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        type: null,
        content: null,
        resourceId: null,
        resourceType: null,
        processStatus: 0,
        processResult: null,
        createTime: null,
        remark: null,
      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {

      this.resourceType = row.resourceType;
      this.resourceId = row.resourceId;

      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getUserReport({"id":id}).then(response => {
        this.form = response.data
        this.form.processStatus = 2
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      let that = this;
      that.$refs.form.validate(valid => {
        if (valid) {
          that.submitLoading = true
          if (that.form.id !== undefined && that.form.id !== null) {
            updateUserReport(that.form).then(response => {
              that.$message.success(
                '修改成功',
                3
              )
              if(that.form.processStatus == 2 && that.resourceType == 1){  //当举报的是视频时
                let data = []
                data.push({"id":that.resourceId});
                that.$confirm({
                  title: '是否同时下架此视频?',
                  content: '',
                  onOk () {
                    //调用下架视频业务
                    request({
                        url: '/platform/video/delete',
                        method: 'post',
                        data: data
                      }) .then(() => {
                        that.open = false
                        that.$emit('ok')
                    })
                  },
                  onCancel () {
                    that.open = false
                    that.$emit('ok')
                  }
                })

              }else{
                that.open = false
                that.$emit('ok')
              }
            }).finally(() => {
              that.submitLoading = false
            })
          } else {
            addUserReport(that.form).then(response => {
              that.$message.success(
                '新增成功',
                3
              )
              that.open = false
              that.$emit('ok')
            }).finally(() => {
              that.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
